const namespace = 'Toasts';

export const ADD_TOAST = `${namespace}/ADD_TOAST`;
export const REMOVE_TOAST = `${namespace}/REMOVE_TOAST`;
